import { BaseComponent } from '../../base-component';
import { waitForAllPreloadedScriptsToBeLoaded } from '../../_common/client/otto-preloaded-scripts-helper';
import { WindowLocation } from '../../_common/client/window-location';
import { shareNative } from '@otto-ec/apps-api/sharing';

export class ShareBtnComponent extends BaseComponent {
    public rootSelector = '.js_pdp_share-btn';

    private shareType: 'webshareapi' | 'native' | undefined;

    public async init(): Promise<void> {
        /*                                            */
        await waitForAllPreloadedScriptsToBeLoaded();

        if (!!window.navigator.share) {
            this.shareType = 'webshareapi';
        } else if (window.o_apps?.runningInApp()) {
            this.shareType = 'native';
        }
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.shareType) {
            this.hide();
            return;
        }

        const isAndroid = o_global.device.os == 'Android';
        /*                                  */
        this.setIcon(isAndroid ? 'share' : 'share-ios');

        this.getRootElement().addEventListener('click', () => this.doShare());

        const isValidVariation = this.getRootElement().dataset.isValidVariation === 'true';

        const shouldShow = isValidVariation && !!this.shareType;

        shouldShow ? this.show() : this.hide();
    }

    public async doShare(): Promise<void> {
        const shareUrl = this.createShareUrl();

        switch (this.shareType) {
            case 'native':
                await this.doShareNative(shareUrl);
                break;
            case 'webshareapi':
                await this.doShareWebShareApi(shareUrl);
                break;
            default:
                throw Error(`unknown share type: ${this.shareType}`);
        }
    }

    /**
 *
 *
 */
    private async doShareNative(url: string): Promise<void> {
        shareNative({ url: url, type: 'product' });
    }

    /**
 *
 */
    private async doShareWebShareApi(url: string): Promise<void> {
        const shareData = {
            title: 'OTTO',
            text: 'Schau mal, was ich bei OTTO gefunden habe – was hältst du davon? ',
            url: url,
        };
        await navigator.share(shareData);
    }

    private createShareUrl(): string {
        const variationId = this.getVariationId();
        const shareType = this.getShareTypeForUrl();
        return `${WindowLocation.getOrigin()}/p/share/${shareType}/${variationId}`;
    }

    private getShareTypeForUrl(): string {
        switch (this.shareType) {
            case 'native':
                return 'n';
            default:
                return 'w';
        }
    }

    private setIcon(iconId: string): void {
        this.getRootElement().setAttribute('icon-type-left', iconId);
    }
}
